import { useEffect, useState } from 'react'

const calcDevices = width => {
    // const isMobile = width < 992
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    return { isMobile, isDesktop: !isMobile }
}

const useDevices = (func, deps) => {
    const [devices, setDevices] = useState(calcDevices(window.innerWidth))

    const handleResize = e => {
        setDevices(calcDevices(e.target.innerWidth))
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return devices
}

export default useDevices
